module.exports = __webpack_public_path__ + "img/bgc2.48a9cd91.png";